import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { ErrorDialog } from 'components/Shared/Dialogs/ErrorDialog'
import { RelatedCarErrorMessage, RelatedOrdersErrorMessage } from 'components/Shared/Dialogs/DialogContents'
import { deleteDriver, fetchDrivers } from 'services'
import Table from 'components/Shared/Table'
import { HTTP_404_ERROR } from 'Constants'
import { useErrorHandling } from 'context/errorHandling'
import { createColumns } from 'components/Drivers/DriverTable/columns'
import { DRIVER_CREATE, DRIVER_DELETE, DRIVER_EDIT, useAuth } from 'context/auth'
import { Loader } from 'components/Shared/Loader'

export function DriversTable () {
  let history = useHistory()
  const [relatedOrdersErrors, setRelatedOrdersErrors] = useState([])
  const [relatedCarsError, setRelatedCarsError] = useState()
  const [columnDefinitions, setColumnDefinitions] = useState(null)
  const { handleError } = useErrorHandling()
  const { hasAnyPrivileges } = useAuth()

  useEffect(() => {
          setColumnDefinitions(createColumns(hasAnyPrivileges))
  }, [hasAnyPrivileges])

  const addDriver = () => {
    history.push('/drivers/create')
  }

  const showDriverDetails = (row) => {
    history.push('/drivers/details/' + row.id)
  }

  const editDriver = (row) => {
    history.push('/drivers/edit/' + row.id)
  }

  const onDeleteError = (error) => {
    if (error?.response?.data?.data?.ordersId) {
      setRelatedOrdersErrors(error.response.data.data.ordersId)
    } else if (error?.response?.data?.data?.carId) {
      setRelatedCarsError(error.response.data.data.carId)
    } else {
      handleError(error, {
        [HTTP_404_ERROR]: 'notifications.error.delete'
      }).then(() => setRelatedOrdersErrors([]))
    }
  }

  const addButton = {
    label: 'driver.driverTable.addButtonLabel',
    onClick: addDriver,
    isClickable: hasAnyPrivileges([DRIVER_CREATE])
  }

  const menuOptions = {
    edit: {
      onClick: editDriver,
      isEditable: () => hasAnyPrivileges([DRIVER_EDIT])
    },
    delete: {
      onDelete: deleteDriver,
      onDeleteError: onDeleteError,
      deleteDialog: {
        content: 'driver.driverTable.deleteDialog.content',
        title: 'driver.driverTable.deleteDialog.title'
      },
      isDeletable: () => hasAnyPrivileges([DRIVER_DELETE])
    }
  }

  return (
    columnDefinitions ? <>
      <Table title={'driver.driverTable.title'}
             addButton={addButton}
             fetchData={fetchDrivers}
             columns={columnDefinitions}
             tableKey={'drivers'}
             onRowClick={showDriverDetails}
             menu={menuOptions}/>
      <ErrorDialog
        open={!!relatedOrdersErrors && relatedOrdersErrors.length > 0}
        onClose={() => {
          setRelatedOrdersErrors([])
        }}
        content={<RelatedOrdersErrorMessage idList={relatedOrdersErrors}/>}/>
      <ErrorDialog open={!!relatedCarsError}
                   onClose={() => {
                     setRelatedCarsError(null)
                   }}
                   content={<RelatedCarErrorMessage id={relatedCarsError}/>}/>
    </> : <Loader/>
  )

}

